import { BEATS } from "./story";
import "./hero3d.css";

const pad = (n) => String(n).padStart(2, "0");

export default function HeroStatic() {
  return (
    <section className="sh3 sh3-static" aria-label="SEPLA manufacturing story" data-testid="hero-static">
      <div className="sh3-static-hero">
        <img src="/hero-poster.jpg?v=2" alt="Polished stainless steel Sepla pot" data-testid="static-hero-poster" />
        <div className="sh3-intro sh3-static-intro">
          <p className="sh3-kicker">Stainless Steel · B2B Manufacturer</p>
          <h1 className="sh3-brand">SEPLA</h1>
          <p className="sh3-tagline">Crafting steel <em>since 1970</em></p>
          <p className="sh3-mono-line">HOTELWARE • KITCHENWARE • BUFFET &amp; CATERING</p>
          <a className="sh3-btn sh3-static-skip" href="#the-range" data-testid="skip-intro-button">Skip intro ↓</a>
        </div>
      </div>

      <ol className="sh3-static-list" data-testid="static-chapter-list">
        {BEATS.map((b, i) => (
          <li key={b.short} data-testid={`static-chapter-${i + 1}`}>
            <span>{pad(i + 1)} / {pad(BEATS.length)}</span>
            <h2>{b.name}</h2>
            <p>{b.copy}</p>
            {b.cta && <a className="sh3-cta" href="#contact" data-testid="cta-bulk-quote">Request a bulk quote</a>}
          </li>
        ))}
      </ol>
    </section>
  );
}
